/* lua.js generated code 0.3.0 */

if (ccui) {
    // ccui.BrightStyle = table(
    //     [1, "none", -1],
    //     [1, "normal", 0],
    //     [1, "highlight", 1]
    // )
    // ccui.TextureResType = table([1, "localType", 0], [1, "plistType", 1])
    // ccui.TouchEventType = table(
    //     [1, "began", 0],
    //     [1, "moved", 1],
    //     [1, "ended", 2],
    //     [1, "canceled", 3]
    // )
    // ccui.SizeType = table([1, "absolute", 0], [1, "percent", 1])
    // ccui.PositionType = table([1, "absolute", 0], [1, "percent", 1])
    // ccui.CheckBoxEventType = table([1, "selected", 0], [1, "unselected", 1])
    ccui.TextFiledEventType = table(
        [1, "attach_with_ime", 0],
        [1, "detach_with_ime", 1],
        [1, "insert_text", 2],
        [1, "delete_backward", 3]
    )
    ccui.LayoutBackGroundColorType = table(
        [1, "none", 0],
        [1, "solid", 1],
        [1, "gradient", 2]
    )
    // ccui.LayoutType = table(
    //     [1, "ABSOLUTE", 0],
    //     [1, "VERTICAL", 1],
    //     [1, "HORIZONTAL", 2],
    //     [1, "RELATIVE", 3]
    // )
    // ccui.LayoutParameterType = table(
    //     [1, "none", 0],
    //     [1, "linear", 1],
    //     [1, "relative", 2]
    // )
    // ccui.LinearGravity = table(
    //     [1, "none", 0],
    //     [1, "left", 1],
    //     [1, "top", 2],
    //     [1, "right", 3],
    //     [1, "bottom", 4],
    //     [1, "centerVertical", 5],
    //     [1, "centerHorizontal", 6]
    // )
    // ccui.RelativeAlign = table(
    //     [1, "alignNone", 0],
    //     [1, "alignParentTopLeft", 1],
    //     [1, "alignParentTopCenterHorizontal", 2],
    //     [1, "alignParentTopRight", 3],
    //     [1, "alignParentLeftCenterVertical", 4],
    //     [1, "centerInParent", 5],
    //     [1, "alignParentRightCenterVertical", 6],
    //     [1, "alignParentLeftBottom", 7],
    //     [1, "alignParentBottomCenterHorizontal", 8],
    //     [1, "alignParentRightBottom", 9],
    //     [1, "locationAboveLeftAlign", 10],
    //     [1, "locationAboveCenter", 11],
    //     [1, "locationAboveRightAlign", 12],
    //     [1, "locationLeftOfTopAlign", 13],
    //     [1, "locationLeftOfCenter", 14],
    //     [1, "locationLeftOfBottomAlign", 15],
    //     [1, "locationRightOfTopAlign", 16],
    //     [1, "locationRightOfCenter", 17],
    //     [1, "locationRightOfBottomAlign", 18],
    //     [1, "locationBelowLeftAlign", 19],
    //     [1, "locationBelowCenter", 20],
    //     [1, "locationBelowRightAlign", 21]
    // )
    ccui.SliderEventType = table([1, "percentChanged", 0])
    // ccui.LoadingBarDirection = table([1, "LEFT", 0], [1, "RIGHT", 1])
    ccui.ScrollViewDir = table(
        [1, "none", 0],
        [1, "vertical", 1],
        [1, "horizontal", 2],
        [1, "both", 3]
    )
    // ccui.ScrollViewMoveDir = table(
    //     [1, "none", 0],
    //     [1, "up", 1],
    //     [1, "down", 2],
    //     [1, "left", 3],
    //     [1, "right", 4]
    // )
    ccui.ScrollviewEventType = table(
        [1, "scrollToTop", 0],
        [1, "scrollToBottom", 1],
        [1, "scrollToLeft", 2],
        [1, "scrollToRight", 3],
        [1, "scrolling", 4],
        [1, "bounceTop", 5],
        [1, "bounceBottom", 6],
        [1, "bounceLeft", 7],
        [1, "bounceRight", 8]
    )
    // ccui.ListViewDirection = table(
    //     [1, "none", 0],
    //     [1, "vertical", 1],
    //     [1, "horizontal", 2]
    // )
    // ccui.ListViewMoveDirection = table(
    //     [1, "none", 0],
    //     [1, "up", 1],
    //     [1, "down", 2],
    //     [1, "left", 3],
    //     [1, "right", 4]
    // )
    // ccui.ListViewEventType = table([1, "ONSELECTEDITEM_START", 0], [1, "ONSELECTEDITEM_END", 1])
    // ccui.PageViewEventType = table([1, "turning", 0])
    // ccui.PVTouchDir = table([1, "touchLeft", 0], [1, "touchRight", 1])
    // ccui.ListViewGravity = table(
    //     [1, "left", 0],
    //     [1, "right", 1],
    //     [1, "centerHorizontal", 2],
    //     [1, "top", 3],
    //     [1, "bottom", 4],
    //     [1, "centerVertical", 5]
    // )
    // ccui.TextType = table([1, "SYSTEM", 0], [1, "TTF", 1])
    // ccui.LayoutComponent.HorizontalEdge = table(
    //     [1, "None", 0],
    //     [1, "Left", 1],
    //     [1, "Right", 2],
    //     [1, "Center", 3]
    // )
    // ccui.LayoutComponent.VerticalEdge = table(
    //     [1, "None", 0],
    //     [1, "Bottom", 1],
    //     [1, "Top", 2],
    //     [1, "Center", 3]
    // )
}

